<template>
  <div class="footerWrap">
    <div class="footer">
      <div class="footerT">
        <img :src="logoImg" alt="">
        <div class="txt">
          <p>-上海迎龙文化传播有限公司- Copyright@2015 mf.818long.Com 版权所有|<a
              href="https://beian.miit.gov.cn/#/Integrated/index"><span
                style="color: #c77552;">【沪ICP备14028053号-1】</span></a></p>
          <p><span
              style="color: rgb(78, 78, 78);">【文网备字（2009）46号】，游戏版号【沪新出音[2009]131号/科技与数字[2009]152号】</span>沪网文【2018】5431-376
            号，ICP证： 沪B2-20130056|</p>
          <p class="picture">
            <a href="http://scjgj.sh.gov.cn/lz/licenseLink.do?method=licenceView&entyId=20130426140349500">
              <img :src="b_img" alt="">
            </a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602009207">
              <img :src="beian" alt="">
              <span>沪公网安备 31010602009207号</span>
            </a>
            <a href="http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/">
              <img :src="w_log" alt="">
            </a>
          </p>
        </div>
        <!-- <img :src="footer3" alt=""> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      w_log: require('@/assets/imgs/foot/w_log.png'),
      logoImg: require('@/assets/imgs/foot/logo.png'),
      beian: require('@/assets/imgs/foot/beian.png'),
      b_img: require('@/assets/imgs/foot/b_img.png'),
    }
  },
  methods: {
  },
}
</script>
<style scoped lang="less">
.footerWrap {
  padding: 20px 0;
  background: #f6e6d5;

  .footerT {
    display: flex;
    align-items: flex-start;

    .txt {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      p {
        margin: 5px 0;
      }

      .picture {
        display: flex;
        align-items: center;
        margin-top: 10px;
        a{
          margin: 0 5px;
        }
        span {
          margin: 0px 0px 0px 5px;
          color: #939393;
        }


      }
    }
  }

  .footer {
    margin: 0 auto;
    width: 1100px;
    text-align: center;
  }
}
</style>
